/** Unity component type name -> simulated behaviour class. */
import type { GameBehaviour } from '../game.ts';
import type { SimGo } from '../world.ts';
import { PlayerController } from '../player.ts';
import { ActivatorModifier, DashActivator, PlayerActionActivator, SwitchHandler, TimedActivator, ZoneActivator } from './activators.ts';
import { DeathTriggerHandler, DeathZoneHandler, GenericHazardHandler, SpikeHandler } from './hazards.ts';
import { Checkpoint, CheckpointZone, Door, PlayerSpawnPoint } from './level.ts';
import { Coin, ForceDash, Gem, GemShard, GemShardGroup, PowerupCollectable, ReDash, RePack } from './collectables.ts';
import { FadeOutHandler, Oscillator } from './misc.ts';
import { MovingPlatformHandler, PlatformMovePoint } from './movingPlatform.ts';
import { DeadQuarterExploder, SpriteExploder } from './effects.ts';
import { BreakableTilemap } from './breakable.ts';
import { DespawnTimer, DynamicObject, Squishable } from './dynamic.ts';
import { BluePlasmaProjectile, CannonballProjectile, LaserHandler, LauncherBase, ProjectileEmitter, SpikeyBall, SpikeyPatroller } from './enemies.ts';
import { ColorMatchBlock, CrumblePlatform, CrumblePlatformGenerator, DashPlatform, TickTockPlatformHandler, TouchBlock } from './platforms.ts';
import { BodyControlHandler, BodyControlPanel, CameraPreviewHandler, RigidBodyRotator } from './control.ts';
import { CameraController, ParallaxBackground, ParallaxPanel } from '../camera.ts';
import { Animator } from './animator.ts';
import { TheString } from './string.ts';
import { KOTHHandler, Volleyball, VolleyballHandler } from './modes.ts';

export { MovingPlatformHandler, SpikeHandler };

export type BehaviourClass = new (go: SimGo, data: any) => GameBehaviour;

export const REGISTRY: Record<string, BehaviourClass> = {
  PlayerController,
  SwitchHandler,
  ZoneActivator,
  ActivatorModifier,
  TimedActivator,
  DashActivator,
  PlayerActionActivator,
  SpikeHandler,
  DeathZoneHandler,
  DeathTriggerHandler,
  GenericHazardHandler,
  PlayerSpawnPoint,
  Checkpoint,
  CheckpointZone,
  Door,
  Coin,
  Gem,
  GemShard,
  GemShardGroup,
  PowerupCollectable,
  ReDash,
  RePack,
  ForceDash,
  FadeOutHandler,
  Oscillator,
  PlatformMovePoint,
  DeadQuarterExploder,
  CameraController,
  ParallaxBackground,
  ParallaxPanel,
  DynamicObject,
  DespawnTimer,
  Squishable,
  CrumblePlatform,
  CrumblePlatformGenerator,
  TouchBlock,
  TickTockPlatformHandler,
  DashPlatform,
  ColorMatchBlock,
  LaserHandler,
  ProjectileEmitter,
  CannonballProjectile,
  BluePlasmaProjectile,
  SpikeyBall,
  LauncherBase,
  SpikeyPatroller,
  BodyControlHandler,
  BodyControlPanel,
  RigidBodyRotator,
  CameraPreviewHandler,
  BreakableTilemap,
  SpriteExploder,
  Animator,
  TheString,
  KOTHHandler,
  Volleyball,
  VolleyballHandler,
};
